import { WeezSocket } from "@weezevent/piglet";
import { inIframe } from './scroll';


// Params to clear in URL according to the context
const queryParamToClean = {
  'resaleLinkError' : ['token', 'resale_uuid'],
  'cancelCheckResaleLink': ['token', 'resale_uuid'],
  'orderMenu': ['token', 'magic_link'],
  'stepHeader': ['token', 'wz_link', 'email', 'membership_code', 'barcode', 'r', 'magic_link'],
  'waitingListTicketLinkError': ['token', 'waiting_list_ticket'],
}

export const logout = (contextLogout = null, storage) => {
  // clean local storage key according widgetkey
  const queryParamKeys = (contextLogout && queryParamToClean[contextLogout]) ? queryParamToClean[contextLogout] : [];

  storage.remove()
  if (inIframe()) {
      // handle log out from iframe by using websocket (piglet) + clean url queryparam
      try {
        WeezSocket.send(
          {
            type: "clean-url-params",
            origin: "neo",
            payload: {
              paramsKeys: queryParamKeys,
            },
          },
          { needs_answer: false },
        );
      } catch {
        // eslint-disable-next-line no-console
        console.error("Cannot clean the parent URL, check the iframe is properly integrated.");
      }
    } else {
      // handle log out by clearing queryparam
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      queryParamKeys.forEach((key) => {
        params.delete(key);
      });
      const newUrl = `${url.origin}${url.pathname}${url.hash}${params?.size ? `?${params.toString()}` : ""}`;
      window.history.pushState({ path: newUrl }, "", newUrl);
      window.location.reload();
    }
};
